import { NavigationMenuItem, NavigationMenuItemProps } from "common";

export interface ISidebarMenuItemProps extends NavigationMenuItemProps {
  visible?: boolean;
}

export default function SidebarMenuItem(props: ISidebarMenuItemProps) {
  if (!props.visible) {
    return <></>;
  }

  // Fix "boolean" problem. May need a better solution
  const { visible, ...newProps } = props;

  return (
    <NavigationMenuItem
      {...newProps}
      sx={{
        minHeight: "38px!important",
        justifyContent: props.minimized ? "center" : "initial",
        borderRadius: 1,
        //p: 0, // 2.5,
        my: 0.5,
        "& a": {
          flex: 1,
          display: "flex",
          textDecoration: "none",
          alignItems: "center",
          minHeight: "36px",
          color: "text.primary",
          textAlign: props.minimized ? "center" : "left",
          "& .MuiListItemIcon-root": {
            flex: props.minimized ? 1 : 0,
          },
          //alignItems: "center",
          //backgroundColor: "red",
        },
        ...newProps.sx,
      }}
    />
  );
}
